var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonExportJson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui-button editor-button",
    width: "100%",
    height: "100%",
    viewBox: "0 0 382 240",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "export-button"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "interior-background",
    x: 0,
    y: 31.366,
    width: 333.333,
    height: 208.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.333,31.366l-333.333,0l-0,208.333l333.333,0l0,-208.333Zm-12.5,12.5l0,183.333c0,0 -308.333,0 -308.333,0c-0,0 -0,-183.333 -0,-183.333l308.333,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.082,73.187c0,1.671 0.423,2.862 1.27,3.573c0.846,0.711 1.774,1.126 2.783,1.245l-0,1.904c-1.932,-0.195 -3.529,-0.762 -4.793,-1.7c-1.265,-0.939 -1.897,-2.483 -1.897,-4.631l0,-3.353c0,-1.183 -0.184,-2.116 -0.553,-2.799c-0.673,-1.248 -1.964,-1.975 -3.874,-2.181l0,-1.856c1.921,-0.228 3.212,-0.938 3.874,-2.132c0.369,-0.662 0.553,-1.611 0.553,-2.848l0,-2.653c0,-2.04 0.443,-3.657 1.327,-4.851c0.884,-1.193 2.672,-1.904 5.363,-2.132l-0,1.856c-1.747,0.152 -2.93,0.922 -3.548,2.311c-0.337,0.76 -0.505,1.812 -0.505,3.158l0,1.822c0,1.628 -0.201,2.876 -0.602,3.744c-0.727,1.573 -2.138,2.458 -4.232,2.653c2.083,0.184 3.494,1.096 4.232,2.734c0.401,0.901 0.602,2.127 0.602,3.679l0,2.457Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.104,96.657l-0.489,9.571l-1.969,-0l-0.505,-9.571l2.963,0Zm-5.583,0l-0.472,9.571l-1.97,-0l-0.504,-9.571l2.946,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.981,96.657l-0.489,9.571l-1.969,-0l-0.505,-9.571l2.963,0Zm-5.583,0l-0.472,9.571l-1.97,-0l-0.504,-9.571l2.946,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.645,103.363l3.401,0l0,3.548l-3.401,0l-0,-3.548Zm-0,13.656l3.401,-0l0,3.548l-3.401,-0l-0,-3.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.335,96.657l-0.488,9.571l-1.969,-0l-0.505,-9.571l2.962,0Zm-5.582,0l-0.472,9.571l-1.97,-0l-0.504,-9.571l2.946,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.257,96.657l-0.489,9.571l-1.969,-0l-0.505,-9.571l2.963,0Zm-5.583,0l-0.472,9.571l-1.97,-0l-0.504,-9.571l2.946,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.993,123.969c0.749,-0.131 1.275,-0.657 1.579,-1.579c0.162,-0.488 0.244,-0.96 0.244,-1.416c-0,-0.076 -0.003,-0.144 -0.008,-0.204c-0.006,-0.059 -0.019,-0.127 -0.041,-0.203l-1.774,-0l-0,-3.548l3.483,-0l-0,3.287c-0,1.292 -0.26,2.426 -0.781,3.402c-0.521,0.977 -1.422,1.579 -2.702,1.807l-0,-1.546Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.104,144.118l-0.489,9.571l-1.969,-0l-0.505,-9.571l2.963,0Zm-5.583,0l-0.472,9.571l-1.97,-0l-0.504,-9.571l2.946,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.981,144.118l-0.489,9.571l-1.969,-0l-0.505,-9.571l2.963,0Zm-5.583,0l-0.472,9.571l-1.97,-0l-0.504,-9.571l2.946,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.645,150.824l3.401,0l0,3.548l-3.401,0l-0,-3.548Zm-0,13.656l3.401,-0l0,3.548l-3.401,-0l-0,-3.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.335,144.118l-0.488,9.571l-1.969,-0l-0.505,-9.571l2.962,0Zm-5.582,0l-0.472,9.571l-1.97,-0l-0.504,-9.571l2.946,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.257,144.118l-0.489,9.571l-1.969,-0l-0.505,-9.571l2.963,0Zm-5.583,0l-0.472,9.571l-1.97,-0l-0.504,-9.571l2.946,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.993,171.43c0.749,-0.131 1.275,-0.657 1.579,-1.579c0.162,-0.489 0.244,-0.961 0.244,-1.416c-0,-0.076 -0.003,-0.144 -0.008,-0.204c-0.006,-0.059 -0.019,-0.127 -0.041,-0.203l-1.774,-0l-0,-3.548l3.483,-0l-0,3.287c-0,1.292 -0.26,2.426 -0.781,3.402c-0.521,0.977 -1.422,1.579 -2.702,1.807l-0,-1.546Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.272,206.7c-2.083,-0.196 -3.488,-1.074 -4.215,-2.637c-0.402,-0.868 -0.603,-2.121 -0.603,-3.76l0,-1.823c0,-1.432 -0.168,-2.517 -0.504,-3.255c-0.608,-1.324 -1.79,-2.062 -3.548,-2.213l-0,-1.856c2.799,0.228 4.698,1.096 5.696,2.604c0.651,0.966 0.977,2.425 0.977,4.379l-0,2.653c-0,1.215 0.184,2.159 0.553,2.832c0.673,1.226 1.97,1.942 3.89,2.148l0,1.855c-1.909,0.196 -3.206,0.928 -3.89,2.198c-0.369,0.694 -0.553,1.622 -0.553,2.783l-0,3.353c-0,2.192 -0.632,3.743 -1.896,4.655c-1.264,0.911 -2.857,1.47 -4.777,1.676l-0,-1.904c1.161,-0.152 2.126,-0.616 2.897,-1.392c0.77,-0.776 1.155,-1.918 1.155,-3.426l0,-2.458c0,-1.562 0.201,-2.788 0.603,-3.678c0.738,-1.638 2.143,-2.55 4.215,-2.734Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.982,
    y: 147.134,
    width: 27.481,
    height: 20.833
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.982,
    y: 99.673,
    width: 27.481,
    height: 20.833
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.539,
    y: 155.467,
    width: 69.736,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.539,
    y: 108.006,
    width: 69.736,
    height: 12.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "change-button"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "interior-background",
    cx: 318.919,
    cy: 62.5,
    r: 62.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.919,-0c34.495,-0 62.5,28.005 62.5,62.5c0,34.495 -28.005,62.5 -62.5,62.5c-34.494,-0 -62.5,-28.005 -62.5,-62.5c0,-34.495 28.006,-62.5 62.5,-62.5Zm0,16.667c25.296,-0 45.834,20.537 45.834,45.833c-0,25.296 -20.538,45.833 -45.834,45.833c-25.296,0 -45.833,-20.537 -45.833,-45.833c0,-25.296 20.537,-45.833 45.833,-45.833Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.586,
    y: 33.333,
    width: 16.667,
    height: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.919,95.833l-25,-25l50,0l-25,25Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonExportJson);
export default __webpack_public_path__ + "static/media/button-export-json.f73d4faa.svg";
export { ForwardRef as ReactComponent };